var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxHeaderOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 601.824 66.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BoxHeader_orange",
    d: "M87.051,66.994c58.458-1.723,241.52-.854,241.52-.854l177.731.854s63.816-2.266,95.745-2.215l-1.6-64.2-101.6,2.033L298.9,6.039,198.92,5.792,98.94,1,.223,2.815V66.994",
    transform: "translate(-0.223 -0.574)",
    fill: "#c78b43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxHeaderOrange);
export default __webpack_public_path__ + "static/media/BoxHeader_orange.795224c7a4d3b2f454fb0b093ec8772d.svg";
export { ForwardRef as ReactComponent };